function remove_invalid_feedback(input,feedback_container,edge_cases){
	if(edge_cases=="ql-editor"){
		 var container = input + " .ql-editor"
		$(container).removeClass("border-danger");
	}else if(edge_cases=="country_selector"){
	  $(input).next().find('.select2-selection').removeClass('border-danger');
	}else{
	  $(input).removeClass("is-invalid");
	}

	if($(feedback_container).length){
	  $(feedback_container).remove();
	}
}
export default remove_invalid_feedback;